import {
  Alert,
  Box,
  Button,
  Fade,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ContainedButton, CTextField } from "./CustomStyles";
import { isValidEmail } from "../../hooks/HelperFunctions";
import { useEffect, useState } from "react";
import axios from "axios";
import { Poppins } from "next/font/google";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const ContinueButtonStyle = {
  padding: "16px",
  borderRadius: "10px",
};

const ForgotPassword = (props) => {
  const {
    email,
    phone,
    password,
    setEmail,
    setPhone,
    signInWith,
    handleClose,
    setAuthSteps,
    setAuthState,
    handleConfirm,
    forgotPasswordMode,
    showToastWithMessage,
    setForgotPasswordMode,
  } = props;

  const [emailError, setEmailError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false)

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  let FalseEmail = true;

  const sendForgetEmailPasswordHandler = () => {
    setErrorMessage("");
    if (!isValidEmail(email)) {
      setEmailError("Enter a valid email address");
      setShowLoader(false)
      return false;
    }

    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["token"] = token;

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendEmailForForgetPassword`, postData)
          .then((response) => {
            setShowLoader(false)
            if (!response?.data?.error) {
              setAuthSteps(2);
              setForgotPasswordMode(true);
              showToastWithMessage("Code sent");
            }
          })
          .catch((err) => {
            setShowLoader(false)
            console.log(err);
            if (err?.response?.data?.message) {
              setErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false)
        console.error("Error:", error);
      }
    });
  };
  const sendForgetPhonePasswordHandler = () => {};

  const continueHandler = () => {
    setShowLoader(true)
    if (signInWith == "email") {
      sendForgetEmailPasswordHandler();
    } else {
      sendForgetPhonePasswordHandler();
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            color: "#0B132B",
            fontSize: "16px",
            fontFamily: poppins.style.fontFamily,
          }}
        >
          Enter the {signInWith == "email" ? "email address" : "phone number"}{" "}
          associated with your account to change your password.
        </Typography>
        {errorMessage != "" && (
          <Fade in={errorMessage != ""}>
            <Alert
              severity="warning"
              icon={<InfoOutlinedIcon />}
              sx={{
                mt: 2,
                height: "60px",
                fontFamily: poppins.style.fontFamily,
                alignItems: "center",
                backgroundColor: "rgba(239, 117, 49, 0.12) !important",
              }}
            >
              We sent you password reset instructions if the email is  <br /> associated with a Takbir account.
            </Alert>
          </Fade>
        )}

        <CTextField
          placeholder="Enter email address"
          // error
          onChange={(e) => {
            setEmail(e.target.value.toLowerCase());
            setEmailError("");
          }}
          value={email}
          helperText={emailError}
          error={emailError != ""}
          sx={{ mt: 2, mb: 4 }}
        />
        <ContainedButton
          variant="contained"
          fullWidth
          // sx={ContinueButtonStyle}
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={() => {
            continueHandler();
          }}
        >
          Next
        </ContainedButton>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default ForgotPassword;
